<div class="zoom-button">
    <canvas id='cameraNavCanvas' [width]="size" [height]="size"
            (mousedown)="doActionFromRegion($event)" (mouseup)="doUpActionFromRegion($event)"
            (mousemove)="update($event);" (mouseout)="update(false)"></canvas>
    </div>